"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastMigrationVersion = exports.migrateStory = void 0;
var migrateDialog_1 = require("./migrateDialog");
Object.defineProperty(exports, "migrateStory", { enumerable: true, get: function () { return migrateDialog_1.migrateStory; } });
var migrations_1 = require("./migrations");
Object.defineProperty(exports, "lastMigrationVersion", { enumerable: true, get: function () { return migrations_1.lastMigrationVersion; } });
//# sourceMappingURL=index.js.map